import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF7]" data-testid="app-layout">
      <Header />
      <main className="flex-1" data-testid="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}
